<template>
  <section>
    <h1 class="section-head">รายงานลูกหนี้</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          
        </div>
      </div>
      <div class="level-center">
        <div class="level-item">
            
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            
          </div>
        </div>
      </div>
    </nav>
    <div class="columns">
      
      <div class="column is-8">
        <h4 class="section-mini-head">Report </h4>
        <b-table
          :data="displayData"
          :selected.sync="selectedItem"
          :hoverable="true"
          :loading="isTableLoading"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :narrowed="true"
          v-if="orders.length > 0 || isTableLoading"
        >
          <template slot-scope="props">
            <b-table-column field="name" label="Company">
                {{ props.row.name ? props.row.name : ""}}
            </b-table-column>
            <b-table-column field="total" label="มูลค่ารวม (บาท)" width="150">
                {{ props.row.total ? parseFloat(props.row.total).formatMoney(2):0 }} บาท
            </b-table-column>
            <b-table-column label="พิมพ์" width="150">
                <b-button size="is-small" type="is-info" icon-left="print" @click="printpdf(props.row.cus_id)">Print</b-button>
            </b-table-column>
          </template>
        </b-table>
        <div class="notification has-text-centered" v-else>ไม่พบข้อมูล</div>
      </div>
      <div class="column">
          <h4 class="section-mini-head">Summary</h4>

          
          <div class="notification">
            <div class="content">
              <h4 >
                  ยอดรวม
              </h4>
              <h2 class="is-marginless">
                  {{parseFloat(this.grandTotal).formatMoney(2)}} บาท
              </h2>
            </div>
          </div>
          <b-button class="pull-right" type="is-info" icon-left="print" @click="printpdf()">พิมพ์ทุกราย</b-button>
      </div>
    </div>
  </section>
</template>

<script>
  import CustomerModel from '@/model/customer_model';
  import OrderModel from '@/model/order_model'
  import Const from '@/const/const'
  import moment from 'moment';
  import Config from "@/libraries/config";

  export default {
    data() {
      return {
        orders: [],
        customerList: [],
        company: "",
        dateStart: new Date(),
        dateEnd: new Date(),
        displayData: [],

        orderDatas: [],
        grandTotal: 0.00,

        isTableLoading: false,
        selectedItem: null,
        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 20,
        search_query: "",
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      filteredCustomerObj() {
          return this.customerList.filter((option) => {
            if(option.name.toString().toLowerCase().indexOf(this.company.toLowerCase()) >= 0){
              return option;
            }else{
              return false;
            }
          });
      },
      filteredData: function() {
        this.grandTotal = 0;
        return this.orders.filter(order => {
          if((
            (order.code && order.code.toLowerCase().includes(this.search_query.toLowerCase()))
            || (order.ship_code && order.ship_code.toLowerCase().includes(this.search_query.toLowerCase()))
            || (order.company && order.company.toLowerCase().includes(this.search_query.toLowerCase()))
          )){
            //this.recalculateData(order);
            return true;
          }else{
            return false;
          }
        })
      }
    },
    methods:{
      async init(){
        this.isTableLoading = true;
        this.orders = await OrderModel.get_order_report(0,0,0,0);
        this.recalculateData();
        this.isTableLoading = false;
      },
      selected(item) {
        if(!this.can("view_order|edit_order|delete_order|issue_receipt|issue_tax_invoice")){
          this.$buefy.toast.open('คุณไม่มีสิทธิ์ที่จะเข้าถึงส่วนนี้!');
          return;
        }
        if(this.lastSelected == item){
          let routeData = this.$router.resolve({ path: '/order/view/'+item.id });
          window.open(routeData.href, '_blank');
          //this.$router.push({ path: '/order/view/'+item.id })
        }
        this.lastSelected = item;
      },
      clean_date(date){
        return moment(date).format("YYYY-MM-DD");
      },
      groupBy(xs, key) {
        return xs.reduce(function(rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, []);
      },
      recalculateData(){
        //this.orderDatas.push(data);
        let self = this;
        //Manipulate Data for chart display
        
        let orders = this.groupBy(this.orders, 'cus_id');
        let reArrangedRevenueDatas = [];
        let productDatas = [];
        let grandTotal = 0.0;
        //console.log(typeof orders);
        //console.log(orders);return;

        orders.forEach(function(order,index) {
          reArrangedRevenueDatas[index] = {
                                  name: "",
                                  cus_id: 0,
                                  total: 0.0,
                                  };
          order.forEach((orderData,orderIndex)=>{
            reArrangedRevenueDatas[index].name = orderData.company;
            reArrangedRevenueDatas[index].cus_id = orderData.cus_id;
            reArrangedRevenueDatas[index].total += parseFloat(orderData.total_price) ? parseFloat(orderData.total_price):0;
            
          });
          grandTotal = parseFloat(grandTotal) + parseFloat(reArrangedRevenueDatas[index].total);
          //console.log(reArrangedRevenueDatas);
        });
        this.grandTotal = grandTotal;
        reArrangedRevenueDatas.sort((a, b) => b.total - a.total);
        reArrangedRevenueDatas.forEach((orderData,orderIndex)=>{
          this.displayData.push(orderData);
        });
        
      },
      printpdf(cus_id){
        if(cus_id){
          window.open(Config.baseUrl +"/v"+Config.version+ "/printpdf/account_receivable?cus_id=" + cus_id, '_blank');
        }else{
          window.open(Config.baseUrl +"/v"+Config.version+ "/printpdf/account_receivable", '_blank');  
        }
      }
    }

  }
</script>

<style scoped>
  .table-style {
    font-size: 0.8rem;
  }

  .table.is-narrow td, .table.is-narrow th {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Report/account_receivable.vue